import {
  cn,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@devhop/ui";
import type {
  AssignedMeetingTaskDTO,
  AssignedProjectTaskDTO,
} from "../api/client";
import { assignedTaskStatusSelectTriggerClass } from "../lib/assignedTaskStatusStyles";
import { useUpdateAssignedTaskStatusMutation } from "../api/queries";

const MEETING_OPTIONS: {
  value: AssignedMeetingTaskDTO["status"];
  label: string;
}[] = [
  { value: "pending", label: "ລໍຖ້າເຮັດ" },
  { value: "done", label: "ສຳເລັດ" },
];

const PROJECT_OPTIONS: {
  value: AssignedProjectTaskDTO["status"];
  label: string;
}[] = [
  { value: "pending", label: "ລໍຖ້າເຮັດ" },
  { value: "in_progress", label: "ກຳລັງເຮັດ" },
  { value: "done", label: "ສຳເລັດ" },
];

type Props =
  | {
      variant: "meeting";
      id: string;
      status: AssignedMeetingTaskDTO["status"];
      className?: string;
    }
  | {
      variant: "project";
      id: string;
      status: AssignedProjectTaskDTO["status"];
      className?: string;
    };

export function AssignedTaskStatusSelect(props: Props) {
  const mutation = useUpdateAssignedTaskStatusMutation();
  const busy =
    mutation.isPending &&
    mutation.variables != null &&
    mutation.variables.id === props.id &&
    ((props.variant === "meeting" && mutation.variables.source === "meeting") ||
      (props.variant === "project" && mutation.variables.source === "project"));

  const options =
    props.variant === "meeting" ? MEETING_OPTIONS : PROJECT_OPTIONS;

  return (
    <Select
      value={props.status}
      disabled={busy}
      onValueChange={(v) => {
        if (v === props.status) return;
        if (props.variant === "meeting") {
          mutation.mutate({
            source: "meeting",
            id: props.id,
            status: v as AssignedMeetingTaskDTO["status"],
          });
          return;
        }
        mutation.mutate({
          source: "project",
          id: props.id,
          status: v as AssignedProjectTaskDTO["status"],
        });
      }}
    >
      <SelectTrigger
        size="sm"
        aria-label="ປ່ຽນສະຖານະວຽກ"
        className={cn(
          "min-w-38",
          assignedTaskStatusSelectTriggerClass(
            props.variant,
            props.status,
          ),
          props.className,
        )}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((o) => (
          <SelectItem key={o.value} value={o.value}>
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
